<template>
  <BHeightAdjuster>
    <BModalBody>
      <div class="list-content">
        <div class="item-content">
          <div
            v-for="opportunityStageMaster in opportunityStageMasters"
            :key="`opportunityStageMaster-${opportunityStageMaster.id}`"
            class="item-row next-action py-400"
          >
            <BLayout
              class="py-100"
              align-center
              justify-space-between
            >
              <BLayout
                class="mr-100"
                align-center
              >
                <div>
                  {{ opportunityStageMaster.stageName }}
                </div>
              </BLayout>
              <BMoreMenu>
                <BPopover
                  placement="top"
                  width="240"
                  trigger="hover"
                  :disabled="opportunityStageMaster.opportunityStageCount == 0"
                  :content="$t('general.alreadyUsed')"
                >
                  <template #reference>
                    <div>
                      <BBtn
                        flat
                        fit
                        size="small"
                        :disabled="opportunityStageMaster.opportunityStageCount > 0"
                        @click="() => handleDelete(opportunityStageMaster.id)"
                      >
                        {{ $t('general.delete.text') }}
                      </BBtn>
                    </div>
                  </template>
                </BPopover>
              </BMoreMenu>
            </BLayout>
          </div>
        </div>
      </div>
    </BModalBody>
  </BHeightAdjuster>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { OpportunityStageMasterApiApiService } from '@/api/user/resources/opportunity_stage_master';
import { useInputValidations } from '@/composable/input-validations';

const { requiredRule } = useInputValidations();
const opportunityStageMasters = ref([]);
const createValid = ref(false);
const inputName = ref('');
const editable = ref({});

const api = new OpportunityStageMasterApiApiService();
const load = async () => {
  const results = await api.getOpportunityStageMasters();
  if (results.data == null) {
    return;
  }
  opportunityStageMasters.value = results.data.opportunityStageMasters;
  for (let i = 0; i < opportunityStageMasters.value.length; i++) {
    editable[i] = false;
  }
};
const handleDelete = async (opportunitySatgeMasterId: number) => {
  await api.deleteOpportunityStageMasters({
    id: opportunitySatgeMasterId,
  });
  load();
};
onMounted(async () => {
  await load();
});
</script>

<style lang="scss" scoped>
.notice {
  color: $textcolor-light;
}
.tbody {
  margin: 32px;
  width: 500px;
}
.row {
  display: flex;
  margin: 24px 0;
  justify-content: space-between;
  justify-items: center;
}
</style>
